module.exports = __webpack_public_path__ + "static/media/infografia_galdisa_diabetes_es.4ce02b81.jpg";